import { atom } from 'jotai';

/**
 * Shared selection state for the Image Choice main-area stage in chat-mode.
 * Tagged with the owning message id so the parent can detect message changes
 * and reset to an empty selection.
 */
export const imageChoiceSelectionAtom = atom<{
  messageId: string | null;
  value: string;
}>({ messageId: null, value: '' });
